<template>
  <a-card style="margin-top: 16px; overflow: hidden" :loading="loadingEvents">
    <h2>Zdarzenia</h2>
    <a-timeline style="padding-top: 1em">
      <a-timeline-item v-for="entry in history" :key="entry.historyId">
        <span style="font-weight: 400;">{{ entry.description }}</span>
        <small style="display: block; line-height: 1.5em">{{ entry.created | moment("HH:mm:ss - DD.MM.yyyy r.") }} &bull; {{
            getDormByCode(entry.dorm).name
          }}</small>
      </a-timeline-item>
    </a-timeline>
    <p><a href="#" @click="goTo({ name: 'Events' })"><small>Zobacz więcej...</small></a></p>
  </a-card>
</template>

<script>
import httpClient from "@/utils/httpClient";

export default {
  name: "SmallHistory",
  data() {
    return {
      history: [],
      dorms: [],
      loadingEvents: true
    }
  },
  mounted() {
    this.loadDorms()
  },
  methods: {
    getHistory() {
      this.loadingEvents = true
      httpClient
          .get(`/admin/history?size=5&page=0`)
          .then((response) => {
            this.history = response.payload;
          }).catch(() => {
        this.$message.error("Nie udało się pobrać zdarzeń.")
      }).finally(() => {
        this.loadingEvents = false
      })
    },

    loadDorms() {
      httpClient
          .get(`/admin/dorms`)
          .then((response) => {
            this.dorms = response;
            this.getHistory()
          }).catch((error) => {
            if (error.response.status !== 401) {
              this.$message.error("Wystąpił błąd z pobraniem listy lokalizacji!")
            }
      })
    },

    getDormByCode(code) {
      return this.dorms.find(dorm => dorm.code === code)
    },

    goTo(obj) {
      if (this.$route.name !== obj.name) {
        this.$router.push(obj);
      }
    },

  }
}
</script>
